import OpsRoutes from "./ops";
import BrandRoutes from "./brand";
import PublisherRoutes from "./publisher";

const PanelRoutes = [...OpsRoutes, ...BrandRoutes, ...PublisherRoutes];

export default PanelRoutes;
